module.exports = __webpack_public_path__ + "img/hr-sand-decal-21.8a93a068.png";